module.exports = __webpack_public_path__ + "static/hightone-a1924b829517ac9dc8fc679a9aabe24b.jpg";